<template>
    <v-navigation-drawer app persistent
                         id="app-drawer"
                         dark
                         ref="app_drawer"
                         class="py-5 px-1 my-nav"
                         :value="drawer_showing"
                         mobile-break-point="991"
                         color="blue-grey darken-4">

        <v-expansion-panels accordion
                            :mandatory="true"
                            :floating="true">
            <v-expansion-panel v-for="group_links of user_group_links"
                               :key="group_links.title">

                <v-expansion-panel-header>{{group_links.title}}</v-expansion-panel-header>

                <v-expansion-panel-content>
                    <v-list dense>
                        <v-list-item-group>
                            <v-list-item
                                    v-for="(link, i) in group_links.links"
                                    :key="i"
                                    :to="link.to">
                                <v-list-item-icon>
                                    <v-icon v-text="link.icon"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="link.text"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-navigation-drawer>

</template>

<script>
    export default {
        data: () => ({
            responsive: false,
            showing_chat: false,
            user_groups: [],
            user_group_links: [],
            default_links: [],
            available_links: [
                {
                    title: 'Admin',
                    access: [1],
                    links: [
                        {
                            to: '/c-panel/admin/customers',
                            icon: 'mdi-account-multiple',
                            text: 'Customers'
                        },
                        {
                            to: '/c-panel/admin/orders',
                            icon: 'mdi-inbox-arrow-down',
                            text: 'Reports'
                        },
                        {
                            to: '/c-panel/admin/live-orders',
                            icon: 'mdi-inbox-arrow-down',
                            text: 'Live Orders'
                        },
                        {
                            to: '/c-panel/admin/promotions',
                            icon: 'mdi-view-dashboard',
                            text: 'Promotions'
                        },

                        {
                            to: '/c-panel/admin/users',
                            icon: 'mdi-account-group',
                            text: 'Logins'
                        },
                        {
                            to: '/c-panel/admin/staff',
                            icon: 'mdi-account-group',
                            text: 'Staff'
                        },
                        {
                            to: '/c-panel/admin/categories',
                            icon: 'mdi-format-list-bulleted',
                            text: 'Drink Categories'
                        },
                    ]
                },
                {
                    title: 'Staff',
                    access: [2],
                    links: [
                        {
                            to: '/c-panel/staff',
                            icon: 'mdi-account-multiple',
                            text: 'Log Screen'
                        },
                    ]
                },
            ],

        }),

        props: {
            drawer: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            drawer_showing: {
                get: function () {
                    return this.drawer
                },
                set: () => this.$emit('toggle-drawer')
            }
        },
        created() {
            if (this.$store.getters.user && this.$store.getters.user_groups)
                this.user_groups = this.$store.getters.user_groups;

            // This can be async
            for (let link of this.available_links)
                for (let group of this.user_groups)
                    if (link.access.includes(group)) {
                        this.user_group_links.push(link);
                        break;
                    }
        },
    }
</script>
<style scoped lang="scss">

    #app-drawer {
        box-shadow: -1px 0 4px #000000BB inset;
        max-height: 100vh;
        height: 100vh;
        width: 260px;
        overflow: no-content;

        & .v-expansion-panel {
            box-shadow: none;
            background-color: transparent;

            &::before {
                box-shadow: none;
            }

            &::after {
                box-shadow: none;
            }

        }


    }


</style>
